/**
 * 系統維護頁面
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSystem } from '../contexts/SystemContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import '../styles/MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();
  const { systemProfile, suspendScope } = useSystem();

  // Layer 2（租戶服務暫停）vs Layer 1（全系統維護）顯不同訊息
  const isTenant = suspendScope === 'tenant';

  return (
    <div className="maintenance-page">
      <div className="maintenance-lang-switcher">
        <LanguageSwitcher />
      </div>
      <div className="maintenance-container">
        <div className="maintenance-icon">{isTenant ? '⏸️' : '🔧'}</div>
        <h1 className="maintenance-title">
          {isTenant ? t('maintenance.tenantTitle', '系統暫停服務') : t('maintenance.title')}
        </h1>
        <h2 className="maintenance-title-en">
          {isTenant ? t('maintenance.tenantTitleEn', 'Service Suspended') : t('maintenance.titleEn')}
        </h2>
        <p className="maintenance-message">
          {isTenant ? t('maintenance.tenantMessage', '本租戶服務目前暫停，請聯絡系統管理員。') : t('maintenance.message')}
        </p>
        <p className="maintenance-message-en">
          {isTenant ? t('maintenance.tenantMessageEn', 'This tenant service is currently suspended. Please contact your system administrator.') : t('maintenance.messageEn')}
        </p>
        <div className="maintenance-info">
          <p>{t('maintenance.apology')}</p>
          <p>{t('maintenance.apologyEn')}</p>
        </div>
        {systemProfile && systemProfile.sys_mana_email && (
          <div className="maintenance-contact">
            <p>{t('maintenance.contact')}</p>
            <p className="contact-email">
              <a href={`mailto:${systemProfile.sys_mana_email}`}>
                {systemProfile.sys_mana_email}
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenancePage;
